// @ts-nocheck
export const CONFIG = {
  VUE_APP_BASEURL: process.env.VUE_APP_BASEURL || "https://b2b.dev.dzing.com",
  VUE_APP_API_URL: process.env.VUE_APP_API_URL || "",
  VUE_APP_X_API_KEY: process.env.VUE_APP_X_API_KEY || "1zOwg92YLPNMarGZ2SpX2z",
    VUE_APP_MODE: process.env.VUE_APP_MODE || "DEV",
  VUE_APP_SENTRY_DSN: process.env.VUE_APP_SENTRY_DSN || "https://5a932531700649d7aa623b92889d9c99@o4504003621945344.ingest.sentry.io/4504135281475584",
  VUA_APP_SECRET: process.env.VUE_APP_SENTRY_DSN || "MYhFLpf8",
  VUE_APP_BUILD_DATE: process.env.VUE_APP_BUILD_DATE,
  IDLE_REGISTRATION_TIMER: 60 * 60 * 1000,
  IDLE_AUTH_TIMER: parseInt(eval(process.env.VUE_APP_IDLE_AUTH_TIMER)) || 15 * 60 * 1000,
  VUE_APP_ZOHO_ASAP_ENABLED: process.env.VUE_APP_ZOHO_ASAP_ENABLED || "",
  VUE_APP_ZOHO_ASAP_SCRIPT_URL: process.env.VUE_APP_ZOHO_ASAP_SCRIPT_URL || "",
  VUE_APP_ZOHO_PORTAL_ID: process.env.VUE_APP_ZOHO_PORTAL_ID || "",
  VUE_APP_ZOHO_APP_ID: process.env.VUE_APP_ZOHO_APP_ID || "",
  LOAN_MODULE_ALLOWED: process.env.VUE_APP_LOAN_MODULE_ALLOWED === "true",
};
